import React from 'react'
import MergeReviewDashboard from './components/MergeReviewDashboard'

const CompanyMergeReviewApp: React.FC = () => {
  return <MergeReviewDashboard />
}

export default CompanyMergeReviewApp
